import { DependenciesPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { IdentityLoginStatus } from '../types/identity-login-status';

export async function getStatusForHandle(
    { clientSdk }: DependenciesPayload,
    handle: string,
): Promise<IdentityLoginStatus> {
    try {
        return await clientSdk.user.status({ handle });
    } catch (error: any) {
        /**
         * TODO:
         * Log error to error logger (not analytics).
         */
        if (error?.code?.includes('identityDoesNotExist')) {
            throw new Error('INVALID_HANDLE');
        } else {
            // TODO: consider passing the error through, status({handle}) may contain a specific code or message other than "SYSTEM" that consumers expect for error handling
            throw new Error('SYSTEM');
        }
    }
}
